var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessDenied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 627.41 458",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-16,.cls-2{fill:#252830;}.cls-3{fill:#d7d7dd;}.cls-4{fill:#cdcdd1;}.cls-5{fill:#eb5623;}.cls-32,.cls-6,.cls-9{fill:none;}.cls-6{stroke:#ffda04;}.cls-6,.cls-9{stroke-linecap:round;}.cls-32,.cls-6{stroke-miterlimit:10;}.cls-7{fill:#fbb019;}.cls-8{fill:#ffda04;}.cls-32,.cls-9{stroke:#fff;}.cls-9{stroke-linejoin:round;}.cls-10,.cls-13{fill:#fffbf2;}.cls-11{fill:#ffae5e;}.cls-12,.cls-14,.cls-19{fill:#606060;}.cls-12{opacity:0.1;}.cls-12,.cls-14,.cls-28,.cls-31,.cls-34,.cls-37,.cls-40,.cls-41{mix-blend-mode:multiply;}.cls-13,.cls-14{opacity:0.3;}.cls-13{mix-blend-mode:screen;}.cls-15{fill:#f0c600;}.cls-15,.cls-39{opacity:0.5;}.cls-16{font-size:32.79px;font-family:SFProDisplay-Bold, SF Pro Display;font-weight:700;}.cls-17{letter-spacing:-0.02em;}.cls-18{fill:#474745;}.cls-20,.cls-39{fill:#fff;}.cls-21,.cls-37{fill:#e0e0e2;}.cls-22{fill:#a5a8ad;}.cls-23{fill:#ffb07e;}.cls-24{fill:#4f3011;}.cls-25{fill:#612005;}.cls-26{fill:#6b1e0f;}.cls-27{fill:#cb7366;}.cls-28{fill:#b3bcc4;}.cls-29{fill:#fcc03a;}.cls-30{fill:#ffd252;}.cls-31{fill:#afaba8;}.cls-31,.cls-32{opacity:0.25;}.cls-32{stroke-width:6px;}.cls-33{fill:#4281a4;}.cls-34,.cls-41{opacity:0.35;}.cls-35,.cls-41{fill:#3a7799;}.cls-36{fill:#292f36;}.cls-38{fill:#343434;}.cls-42{fill:#b7b7b7;}.cls-43{fill:#db5a42;}.cls-44{fill:#9ea8ad;}.cls-45{fill:#879093;}.cls-46{fill:#ff924d;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "access denied_2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M199.43,392.34c15.08,5.32,2.38,11.71-28.36,14.28s-67.87.34-82.95-5-2.37-11.72,28.37-14.29S184.36,387,199.43,392.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M478.88,385.1c42.54,8.63,6.69,19-80.07,23.17s-191.58.55-234.13-8.08-6.69-19,80.07-23.17S436.33,376.47,478.88,385.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M209.28,141.09v8.39H175.14v-8.39a2.17,2.17,0,0,1,0-.36,9.27,9.27,0,0,1,9.27-8.93H200a9.28,9.28,0,0,1,9.27,9.29Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 181.77,
    y: 148.3,
    width: 20.89,
    height: 229.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 160.11,
    y: 377.61,
    width: 64.2,
    height: 17.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M224.31,377.61v17.27H192a12.36,12.36,0,0,0-12.22-10.38h-19.7v-6.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M209.28,141.09v8.39h-6.63V377.71H192.19A18.7,18.7,0,0,0,189,367.65a19.33,19.33,0,0,0-6.73-6.1l-.46-.24V341.93h10.44V277.27a19.35,19.35,0,0,0-3.31-10.87,19.1,19.1,0,0,0-7.13-6.34V240.89h10.44V159.33a18.43,18.43,0,0,0-2.83-9.85,7.84,7.84,0,0,0-.79-1.18,15.76,15.76,0,0,0-1.89-2.22,19,19,0,0,0-5.92-4,18.67,18.67,0,0,0-5.62-1.37,9.27,9.27,0,0,1,9.27-8.93H200a9.28,9.28,0,0,1,9.27,9.29Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 192.45,
    cy: 106.51,
    r: 26.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M212,117.48a22.57,22.57,0,0,1-7.05,7.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M198.22,128.2a22.83,22.83,0,0,1-4.93.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M174.09,93.59a22,22,0,0,1,2.08-2.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M180.39,87.57A22.46,22.46,0,0,1,203.54,87"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 192.45,
    cy: 106.51,
    r: 17.95,
    transform: "translate(-23.23 149.64) rotate(-40.27)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 192.45,
    cy: 106.51,
    r: 11.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M185.68,276V292.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M185.68,368.68v6.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M468.41,141.09v8.39H434.27v-8.39a2.17,2.17,0,0,1,0-.36,9.28,9.28,0,0,1,9.28-8.93h15.57a9.32,9.32,0,0,1,7.13,3.35A9.23,9.23,0,0,1,468.41,141.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 440.9,
    y: 148.3,
    width: 20.89,
    height: 229.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 419.24,
    y: 377.61,
    width: 64.2,
    height: 17.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M483.44,377.61v17.27H451.16a12.36,12.36,0,0,0-12.22-10.38h-19.7v-6.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M468.41,141.09v8.39h-6.62V377.71H451.32a18.7,18.7,0,0,0-3.23-10.06,19.33,19.33,0,0,0-6.73-6.1l-.46-.24V341.93h10.44V277.27A19.35,19.35,0,0,0,448,266.4a19,19,0,0,0-7.13-6.34V240.89h10.44V159.33a18.43,18.43,0,0,0-2.83-9.85,8.59,8.59,0,0,0-.78-1.18,15.84,15.84,0,0,0-1.9-2.22,19,19,0,0,0-5.92-4,18.67,18.67,0,0,0-5.62-1.37,9.28,9.28,0,0,1,9.28-8.93h15.57a9.32,9.32,0,0,1,7.13,3.35A9.23,9.23,0,0,1,468.41,141.09Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 451.58,
    cy: 106.51,
    r: 26.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M471.16,117.48a22.47,22.47,0,0,1-7.05,7.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M457.35,128.2a22.83,22.83,0,0,1-4.92.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M433.22,93.59a23,23,0,0,1,2.08-2.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M439.52,87.57A22.46,22.46,0,0,1,462.67,87"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 451.58,
    cy: 106.51,
    r: 17.95,
    transform: "translate(235.97 517.33) rotate(-75.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 451.58,
    cy: 106.51,
    r: 11.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M444.82,276V292.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M444.82,368.68v6.26"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 147.25,
    y: 300.32,
    width: 349.06,
    height: 50.69
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "185.75 300.32 147.25 338.9 147.25 318.18 165.06 300.32 185.75 300.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "226.28 300.32 175.69 351 154.98 351 205.57 300.32 226.28 300.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "266.78 300.32 216.19 351 195.51 351 246.09 300.32 266.78 300.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "307.3 300.32 256.72 351 236.01 351 286.6 300.32 307.3 300.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "347.83 300.32 297.24 351 276.54 351 327.12 300.32 347.83 300.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "388.33 300.32 337.75 351 317.04 351 367.62 300.32 388.33 300.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "428.85 300.32 378.27 351 357.56 351 408.15 300.32 428.85 300.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "469.36 300.32 418.77 351 398.09 351 448.67 300.32 469.36 300.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "496.31 300.32 496.31 313.94 459.3 351 438.59 351 489.18 300.32 496.31 300.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "496.31 333.77 496.31 351 479.12 351 496.31 333.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M496.31,300.32V351H394.59a112.85,112.85,0,0,0-82.76-35.95H147.25V300.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 147.25,
    y: 148.3,
    width: 349.06,
    height: 101.35
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "208.34 148.3 147.25 209.51 147.25 176.91 175.81 148.3 208.34 148.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "273.4 148.3 172.26 249.65 147.25 249.65 147.25 242.1 240.86 148.3 273.4 148.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "338.45 148.3 237.31 249.65 204.78 249.65 305.93 148.3 338.45 148.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "403.52 148.3 302.37 249.65 269.85 249.65 371 148.3 403.52 148.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "468.59 148.3 367.44 249.65 334.9 249.65 436.05 148.3 468.59 148.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "496.31 153.11 496.31 185.7 432.49 249.65 399.97 249.65 496.31 153.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "496.31 221.7 496.31 249.65 468.41 249.65 496.31 221.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M333.31,233.23h-163a10.15,10.15,0,0,1-10.16-10.15h0a10.16,10.16,0,0,1,10.16-10.16h163a10.14,10.14,0,0,1,10.15,10.16h0A10.15,10.15,0,0,1,333.31,233.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M292.89,343.93H170.27a10.16,10.16,0,0,1-10.16-10.16h0a10.15,10.15,0,0,1,10.16-10.15H292.89a10.15,10.15,0,0,1,10.16,10.15h0A10.16,10.16,0,0,1,292.89,343.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M147.25,148.3v30.59H311.83a112.78,112.78,0,0,1,49.92,11.57l-59.18,59.19h89.77l22.94-22.94a112.7,112.7,0,0,1,12.58,22.94h68.45V148.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M422.79,203.72a9,9,0,0,1-2.52,4.73l-41.19,41.2h-57.3V148.3h51.36l47.13,47.15A9.19,9.19,0,0,1,422.79,203.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M412.7,199.07a6.85,6.85,0,0,1-2,4.86l-89.84,89.83a6.86,6.86,0,0,1-9.7,0l-89.83-89.83a6.85,6.85,0,0,1,0-9.71l68.89-68.88,20.94-21a6.86,6.86,0,0,1,9.7,0l89.84,89.83A6.85,6.85,0,0,1,412.7,199.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M412.7,199.07a6.85,6.85,0,0,1-2,4.86l-89.84,89.83a6.86,6.86,0,0,1-9.7,0L294,276.63l37.34-37.37a51.43,51.43,0,0,0,0-72.76l-41.15-41.16,20.94-21a6.86,6.86,0,0,1,9.7,0l89.84,89.83A6.85,6.85,0,0,1,412.7,199.07Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-16",
    transform: "translate(261.15 189.14)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17"
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 21.98,
    y: 0
  }, "ccess"), /*#__PURE__*/React.createElement("tspan", {
    x: 2.03,
    y: 39.35
  }, "Denied")), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M239.19,202a2.61,2.61,0,1,1,2.61-2.6A2.59,2.59,0,0,1,239.19,202Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M239.72,202a2.61,2.61,0,1,1,2.6-2.6A2.6,2.6,0,0,1,239.72,202Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M392.86,196.76a2.61,2.61,0,1,1-2.6,2.61A2.61,2.61,0,0,1,392.86,196.76Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 392.34,
    cy: 199.37,
    r: 2.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M316,286.94a7.29,7.29,0,0,1-5.17-2.14l-80.56-80.56a7.31,7.31,0,0,1,0-10.33l80.56-80.57a7.49,7.49,0,0,1,10.34,0l80.56,80.57a7.3,7.3,0,0,1,0,10.33L321.17,284.8A7.27,7.27,0,0,1,316,286.94Zm0-173.42a5,5,0,0,0-3.53,1.46l-80.56,80.57a5,5,0,0,0,0,7l80.56,80.56a5.1,5.1,0,0,0,7.06,0l80.56-80.56a5,5,0,0,0,0-7L319.53,115A5,5,0,0,0,316,113.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M189.52,245.24c-32.5,7.44-59.36,6.07-91.54-2.09l.91-44.94.56-27.64,0-1.78.17-1.15,3.89-25.81v-.1l16.57-3.06,7-1,13.88-.33,8.33-.19,12.26-.29,21.8,4,4.12,29.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M105.58,168.55l-4.5,1.49-1.63.53-21.62,7.12a18.57,18.57,0,0,1-5.07,1.43,8.77,8.77,0,0,1-.88,0,9.68,9.68,0,0,1-6.79-3.71L45,146.78a1.78,1.78,0,0,1,.17-2.25l10.6-11.08a1.81,1.81,0,0,1,2.81.22l16.5,22.93c9.61-5.19,22.22-14.25,28.47-14.77l.09-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M212.44,157.29c-7.22-5.48-20.31-14.21-29.14-15.8l-1.19,28.87,27.58,8a9.69,9.69,0,0,0,12.74-2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M161.64,138.23l-.19.75s-.6,15.82-17.06,15.82S127.2,138,127.2,138l0-.36,13.88-.33a33.17,33.17,0,0,0,3.38.16,34.31,34.31,0,0,0,5-.35l12.26-.29c0,.22,0,.43,0,.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M132.72,133l0,3.83c.24,2.2,5.34,11.73,11.94,12h.41c6.61-.32,11.45-9.57,12-11.8,0-1,0-2.46,0-3.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M110.21,93.62c.12-.54.25-1.07.39-1.61V72.61a31.38,31.38,0,0,1-7.91-3.8,27.44,27.44,0,0,0-.41,4.81q0,1.3.12,2.58a30.62,30.62,0,0,0,4.31,13.13C108.21,89.47,109.51,91.16,110.21,93.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M186.5,67.83a29.26,29.26,0,0,1-7.94,4V91.17c.18.64.34,1.29.49,1.94.69-2.54,2-4.28,3.53-4.42A30.58,30.58,0,0,0,187,74.94c0-.65.07-1.3.07-2A24.9,24.9,0,0,0,186.5,67.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M155.54,134.25c-7.53,2.61-15.43,2.31-23.63-.4-13.42-5.4-26.18-14.16-23.56-33a3.4,3.4,0,0,1-2.72,1.94c-2.38,0-4.31-3.87-4.31-8.65s1.93-8.66,4.31-8.66a2.33,2.33,0,0,1,1.05.26,5.12,5.12,0,0,1,2.1,2.47q.23.51.42,1.08a2.25,2.25,0,0,1,.08.24h0c0,.15.09.3.14.45a3.2,3.2,0,0,0,.07-.33,0,0,0,0,0,0,0c.12-.55.26-1.1.41-1.64V72.86l.84.3L178.43,73l.28-.11V88.2c.11.45.22.9.32,1.36a1.36,1.36,0,0,1,0,.17.35.35,0,0,0,0,.11.83.83,0,0,1,0-.15c.05-.15.09-.29.13-.43a10.07,10.07,0,0,1,.56-1.32,4.85,4.85,0,0,1,2-2.22,2.27,2.27,0,0,1,1-.26c2.37,0,4.3,3.87,4.3,8.66s-1.93,8.65-4.3,8.65a3.41,3.41,0,0,1-2.73-1.94C182.79,117.19,172,129.58,155.54,134.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "155.54 137.05 155.54 137.05 155.54 137.05 155.54 137.05"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M127,82.7a7.81,7.81,0,0,0-5.35,3.54,10.61,10.61,0,0,1,13.34.1A7.66,7.66,0,0,0,127,82.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M161.86,82.7a7.66,7.66,0,0,0-8,3.64,10.59,10.59,0,0,1,13.33-.1A7.79,7.79,0,0,0,161.86,82.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_2",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M160.54,88.59a4.84,4.84,0,1,0,5,4.83A4.92,4.92,0,0,0,160.54,88.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M162.64,90.46a1.3,1.3,0,1,0,1.29,1.3A1.3,1.3,0,0,0,162.64,90.46Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_3",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M128.67,88.59a4.84,4.84,0,1,0,5,4.83A4.92,4.92,0,0,0,128.67,88.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M130.26,90.22a1.3,1.3,0,1,0,1.29,1.29A1.3,1.3,0,0,0,130.26,90.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M140.67,107.65c-.83-1.89.72-4.41,3.47-5.89-.23.09-.47.16-.71.26-3.17,1.4-5,4.19-4.14,6.24s4.19,2.57,7.36,1.17a7,7,0,0,0,.67-.34C144.38,110.12,141.49,109.55,140.67,107.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M132.32,116.32a14.82,14.82,0,0,0,25.76,0,25.45,25.45,0,0,1-25.76,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M144.83,137.88c9,0,12.16-2.59,12.16-3.4,0,0,0,0,0,0a54.07,54.07,0,0,1-24.26-.23S135.83,137.88,144.83,137.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M204.78,173.9c0,5,4.88,9,10.91,9s10.91-4,10.91-9-4.88-9-10.91-9S204.78,168.94,204.78,173.9Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 215.47,
    cy: 165.36,
    rx: 12.31,
    ry: 14.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 221.74,
    y: 143.44,
    width: 6.04,
    height: 25.72,
    rx: 3.02,
    ry: 3.02,
    transform: "translate(449.51 312.6) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 215.69,
    y: 136.46,
    width: 6.04,
    height: 28.05,
    rx: 3.02,
    ry: 3.02,
    transform: "translate(437.43 300.96) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 209.65,
    y: 134.44,
    width: 6.04,
    height: 28.05,
    rx: 3.02,
    ry: 3.02,
    transform: "translate(425.34 296.93) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 203.6,
    y: 135.35,
    width: 6.04,
    height: 28.05,
    rx: 3.02,
    ry: 3.02,
    transform: "translate(413.25 298.75) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M212.1,176.51h0a3,3,0,0,0,.58-4.23l-13.34-17.51a3,3,0,0,0-4.24-.57h0a3,3,0,0,0-.57,4.24L206,174.58C207,175.9,210.78,177.52,212.1,176.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M209.65,138.16l-.05.77c0,.5-.06,1.2-.08,2s-.06,1.82-.08,2.87,0,2.17,0,3.29,0,2.24,0,3.3.06,2,.08,2.87.06,1.54.08,2l.05.77,0-.77c0-.49.07-1.19.09-2s.06-1.82.07-2.87,0-2.18,0-3.3,0-2.24,0-3.29,0-2-.07-2.87-.07-1.54-.09-2S209.65,138.16,209.65,138.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M215.69,138.88l0,.76c0,.48-.07,1.18-.09,2s-.06,1.8-.07,2.84,0,2.14,0,3.25,0,2.22,0,3.26,0,2,.07,2.83.07,1.53.09,2l0,.76.05-.76c0-.48.06-1.17.08-2s.06-1.8.08-2.83,0-2.15,0-3.26,0-2.21,0-3.25-.06-2-.08-2.84-.06-1.53-.08-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M221.74,146.26a4.31,4.31,0,0,0-.05.44c0,.27-.06.67-.09,1.14-.06.94-.1,2.2-.1,3.46s0,2.52.1,3.46c0,.48.07.87.09,1.14a4.31,4.31,0,0,0,.05.44s0-.16,0-.44.06-.66.09-1.14c.06-.94.1-2.2.1-3.46s0-2.52-.1-3.46c0-.47-.07-.87-.09-1.14S221.74,146.26,221.74,146.26Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 215.69,
    cy: 173.37,
    rx: 10.58,
    ry: 8.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M205.85,174.37l.14.22c.1.14.22.36.41.61l.31.42.4.47a12.56,12.56,0,0,0,1,1.07l.65.55c.24.17.48.36.74.53a11,11,0,0,0,1.73.95,11.92,11.92,0,0,0,2,.65,12.12,12.12,0,0,0,2.17.24,11.36,11.36,0,0,0,2.18-.23,11.61,11.61,0,0,0,2-.63,11.46,11.46,0,0,0,1.74-.94,13.7,13.7,0,0,0,1.39-1.08,10.41,10.41,0,0,0,1.05-1.06c.28-.33.52-.63.71-.89s.31-.47.41-.6l.14-.22-.16.2c-.11.13-.26.33-.47.56a10.3,10.3,0,0,1-.76.84c-.31.3-.68.63-1.09,1a11.14,11.14,0,0,1-1.4,1,13.62,13.62,0,0,1-1.71.85,12.58,12.58,0,0,1-1.95.59,13.2,13.2,0,0,1-2.09.19,12,12,0,0,1-2.09-.21,11,11,0,0,1-2-.59,14.2,14.2,0,0,1-1.7-.86c-.27-.15-.51-.34-.75-.49l-.66-.51c-.4-.34-.77-.68-1.08-1l-.42-.44-.34-.4c-.21-.23-.35-.43-.46-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M213.17,169.34a4.5,4.5,0,0,0-.13-.54c0-.18-.12-.38-.2-.62s-.17-.5-.3-.77-.27-.58-.43-.89a10.62,10.62,0,0,0-.55-1c-.22-.32-.43-.65-.69-1a11.59,11.59,0,0,0-.81-.92l-.43-.44-.47-.39a7.11,7.11,0,0,0-.95-.71,6,6,0,0,0-1-.56l-.45-.24-.45-.17a7,7,0,0,0-.78-.29l-.63-.16-.54-.12.52.21.59.23c.22.1.46.24.73.37l.42.2.43.27a10.51,10.51,0,0,1,.89.59,10,10,0,0,1,.89.72l.44.39.42.42c.29.28.53.59.79.89s.47.61.7.91.42.6.59.9.35.57.49.83.27.51.38.73a5.6,5.6,0,0,1,.27.58C213.1,169.15,213.17,169.34,213.17,169.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M187.54,68.4c0,.67,0,1.33,0,2H100.34c0-.66,0-1.32,0-2a52.13,52.13,0,0,1,10.34-31.53c8-10.56,19.94-17.26,33.28-17.26C168,19.61,187.54,41.45,187.54,68.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M187.5,70.39H100.34l-5.22,5.1a4.29,4.29,0,0,0,4,4.5h89.54a4.29,4.29,0,0,0,4-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M125.15,24.46l2.46-1.33a115,115,0,0,0,0,23.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M154.21,21.09l2.29.58c-1.74,6.64-2.18,14.79-2.29,23.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M173.73,32.78l2.37,2.74c-1.47.78-3,6.49-4.44,12.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M149.94,15H136.67a4.54,4.54,0,0,0-4.26,4.77V43.58a4.54,4.54,0,0,0,4.26,4.77h13.27a4.54,4.54,0,0,0,4.27-4.77V19.77A4.54,4.54,0,0,0,149.94,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M127.56,44.56l-2.41-20.1a6.48,6.48,0,0,0-.27-1.21c-.54-1.57-1.66-2.6-2.82-2.42l-8.12,1.22c-1.44.22-2.39,2.19-2.12,4.42l.65,5.45,1.76,14.65c.27,2.22,1.65,3.85,3.1,3.63L125.44,49C126.88,48.77,127.83,46.79,127.56,44.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M172.44,22l-8.12-1.15c-1.31-.19-2.59,1.16-3,3.1,0,.18-.07.37-.1.56l-2.55,20.15c-.28,2.23.66,4.2,2.1,4.41l8.11,1.15c1.44.21,2.84-1.43,3.12-3.66l1.68-13.23.87-6.92C174.82,24.16,173.88,22.19,172.44,22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M104.29,66.81c.56-7.6,3.12-18.11,7-22.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M191,293l-4,98.5a17.49,17.49,0,0,0-2.19-2.2c-.24-.2-.48-.4-.74-.59a22.63,22.63,0,0,0-13.65-4.36,22.3,22.3,0,0,0-14.76,5.26c-.24.2-.46.42-.68.64a15.76,15.76,0,0,0-2.34,2.93l-.14-2.91-3.76-79.37c-1.31-1.38-2.34-2.37-4.08-2.73a6.86,6.86,0,0,0-1.65-.17c-2.84,0-3.88,1.13-5.57,2.9l0,.48L134,373.41l-1,18.68-.1-.14-.16-.21a11.7,11.7,0,0,0-.8-.94,14.86,14.86,0,0,0-1.2-1.18,22.28,22.28,0,0,0-14.79-5.29,23.08,23.08,0,0,0-11.64,3,18.68,18.68,0,0,0-2.65,1.85,16,16,0,0,0-2.19,2.17l-3-98.75c0-1.18.06-5.18.21-10.44.08-2.74.18-5.82.27-9,.1-3,.2-6.07.31-9.08.32-9.61.64-18.46.73-20.73,0-.07,0-.14,0-.2h0l9.27-64.45a162,162,0,0,0,73.19-.1l9,66,.11.62c0,.87.11,2.91.21,5.68,0,.08,0,.15,0,.22.13,3.49.3,8.08.48,12.95.1,3,.21,6.07.31,9.08s.21,6.19.29,8.93C191,287.47,191.06,291.64,191,293Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M144.79,250.32a105.67,105.67,0,0,1-29-4.26.59.59,0,1,1,.32-1.14c19.29,5.5,37.62,5.62,54.46.33a.88.88,0,0,0,.61-.83V206.68a.59.59,0,0,1,1.18,0v37.74a2.05,2.05,0,0,1-1.43,2A86.66,86.66,0,0,1,144.79,250.32Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 133.44,
    y: 262.36,
    width: 19.64,
    height: 8.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M107.66,262.15v9.07H96.94c.09-3,.19-6.06.3-9.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 114.27,
    y: 262.15,
    width: 15.7,
    height: 9.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M190.53,271.22H178.77v-9.07h11.44C190.32,265.13,190.43,268.22,190.53,271.22Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 156.56,
    y: 262.15,
    width: 15.6,
    height: 9.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M130,259.13v15.25h26.59V259.13Zm23.11,12H133.45v-8.79h19.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M155.26,387.82l-2.72,2.43-3.76-79.37c-1.31-1.38-2.34-2.37-4.08-2.73a6.86,6.86,0,0,0-1.65-.17c-2.84,0-3.88,1.13-5.57,2.9l0,.48L134,373.41l-1,16.93-.06,1.13c0,.18-.05.34-.08.48a1.92,1.92,0,0,1-.19.63l0-.84,2.77-78.62-.44-11.43a34.39,34.39,0,0,0,6.94-1.63c4.83-1.73,9-4.74,13.45-10C149.84,310.26,153.3,350.67,155.26,387.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M184.83,387.5c-.25-.2-.5-.41-.76-.6a22.94,22.94,0,0,0-13.84-4.42,22.53,22.53,0,0,0-15,5.34c-.24.21-.46.42-.69.64a14.13,14.13,0,0,0-4.45,10.06h40.21A14.46,14.46,0,0,0,184.83,387.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M173.75,385.31l-.28,1.14a36.63,36.63,0,0,1,7.87,3.27l1.72.88.52-1.06c-.57-.28-1.14-.58-1.7-.87A36.24,36.24,0,0,0,173.75,385.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M131.15,389c-.38-.42-.79-.81-1.22-1.2a22.6,22.6,0,0,0-15-5.36,23.55,23.55,0,0,0-11.82,3.07,20.74,20.74,0,0,0-2.69,1.87,14.52,14.52,0,0,0-5.59,11.1h40.21A14,14,0,0,0,131.15,389Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M127.77,390.11l.53-1.05c-.58-.29-1.14-.58-1.7-.88a36.63,36.63,0,0,0-8.13-3.36l-.29,1.14a34.94,34.94,0,0,1,7.88,3.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "129.97 274.38 156.56 274.38 156.56 275.94 129.97 274.38"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M108.68,203l3-.33c1.89-.19,4.6-.5,7.84-.8l1.25-.11a11.19,11.19,0,0,0,1.23-.15,2.76,2.76,0,0,0,1.78-1.4,2.69,2.69,0,0,0,.3-1.15c0-.1,0-.21,0-.31l0-.36-.06-.73c-.07-1-.15-2-.22-3-.15-2-.3-4.13-.45-6.27s-.29-4.3-.43-6.47-.26-4.34-.39-6.48-.23-4.24-.34-6.28c-.21-4.07-.39-7.87-.51-11.13s-.19-6-.26-7.88-.06-3-.06-3,.11,1.08.31,3,.46,4.6.74,7.85.59,7,.89,11.11c.15,2,.3,4.14.45,6.27s.29,4.31.43,6.48l.39,6.47c.11,2.14.23,4.24.34,6.28q.08,1.53.15,3l0,.73,0,.36c0,.14,0,.28,0,.42a3.73,3.73,0,0,1-.46,1.55,3.58,3.58,0,0,1-2.45,1.77,11,11,0,0,1-1.34.11l-1.25.06c-3.25.15-6,.23-7.87.31Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M163.47,202.23l3.24.08c2.06.08,5,.15,8.53.32l1.35.05.35,0h.31a2.34,2.34,0,0,0,.56-.12,2.18,2.18,0,0,0,1.43-1.81c.1-2,.21-4.13.33-6.32.22-4.41.52-9.11.8-13.81s.62-9.39.95-13.8c.17-2.2.33-4.32.48-6.34s.32-3.93.47-5.69c.29-3.52.59-6.45.77-8.5s.32-3.22.32-3.22,0,1.18-.08,3.24-.15,5-.3,8.53c-.08,1.76-.16,3.67-.25,5.7s-.2,4.15-.31,6.35c-.23,4.41-.5,9.11-.79,13.81s-.6,9.4-.93,13.8c-.16,2.22-.3,4.3-.49,6.38a3.12,3.12,0,0,1-2.11,2.52,3.2,3.2,0,0,1-.83.14,2.6,2.6,0,0,1-.39,0l-.34,0-1.35-.12c-3.52-.3-6.44-.62-8.49-.82Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M104.82,141.29,108.68,203l12.13-.85a4,4,0,0,0,3.7-4.23l-3.76-59.67a.52.52,0,0,0-.62-.48l-14.89,2.95A.53.53,0,0,0,104.82,141.29Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: 116.5,
    cy: 192.99,
    rx: 4.62,
    ry: 4.63
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-42",
    cx: 116.03,
    cy: 192.55,
    rx: 4.62,
    ry: 4.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M183.49,141.29l-3.68,58.81a2.91,2.91,0,0,1-3.11,2.72l-13.15-.92,4-63.62a.52.52,0,0,1,.61-.48l14.9,2.95A.53.53,0,0,1,183.49,141.29Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: 172.79,
    cy: 192.77,
    rx: 4.62,
    ry: 4.63
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-42",
    cx: 172.32,
    cy: 192.32,
    rx: 4.62,
    ry: 4.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M189.41,244.62C188,215,186.75,179.9,184.65,167c1.89,4.26,10.67,7.09,19.75,9.87l-16.63-4.65Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "55.97 133.34 45.4 144.38 40.23 138.1 51.47 127.78 55.97 133.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M32.65,138.12c5.32,5,13.3,5.12,17.82.2s3.88-13-1.44-18A13.89,13.89,0,0,0,45,117.59a12.73,12.73,0,0,0-2.71-.86c-4-.83-7.6,3-10.42,6.11-3.05,3.31-4.36,5.32-2.87,9.6a14.43,14.43,0,0,0,3.7,5.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M27.37,132.82l4.9,3.68.09.07,1,.75,3.91,2.91a2.51,2.51,0,0,0,3.52-.67l.39-.54a2.59,2.59,0,0,0-.43-3.6l-2.58-1.93-1.53-1.14-.94-.69-.17-.12-2.22-1.66h0l-4.2-3.12-.62,3.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M28.62,127.68l4.2,3.13h0l2.4,1.79,2.48,1.84a1.44,1.44,0,0,0,2-.39l1.7-2.35a1.5,1.5,0,0,0-.25-2.08l-2.47-1.84-.12-.09-2.07-1.54,0,0L32,122.77l-.12.17-3.1,4.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M32,122.77l4.51,3.36,0,0,2.07,1.54.12.09a2.71,2.71,0,0,0,3.8-.72l.14-.2A2.81,2.81,0,0,0,42.2,123l-.26-.2-2.31-1.72h0s0,0,0,0h0l-4.26-3.17-.11.17-3.12,4.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M35,119.29l.14.09,2.27,1.33c.66.39,1.22.69,1.62.91l.57.32,0,0,0,0-.53-.38c-.37-.26-.89-.64-1.53-1.06s-1.38-.94-2.19-1.46l-.14-.1-.11.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M32,122.77l-.12.17.43.31c.77.56,1.51,1.06,2.13,1.49s1.15.78,1.52,1l.55.36,0,0L36,125.7c-.34-.28-.82-.7-1.42-1.16s-1.29-1-2-1.61l-.43-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M46.71,129a3.46,3.46,0,0,1-.35-.37l-.38-.47a6.16,6.16,0,0,1-.44-.63,8.24,8.24,0,0,1-.47-.79c-.17-.29-.31-.61-.47-.93s-.28-.68-.39-1a10.41,10.41,0,0,1-.3-1.13l-.12-.57c0-.2,0-.39-.07-.59a7.32,7.32,0,0,1-.06-1.14,6.31,6.31,0,0,1,.05-1.08l0-.5.09-.46c.06-.29.11-.56.18-.79s.15-.44.2-.6l.18-.52-.1.53-.12.61c0,.24,0,.51-.1.8l-.05.45c0,.16,0,.32,0,.48a7.23,7.23,0,0,0,0,1,8.29,8.29,0,0,0,.09,1.1l.08.56.12.56a10.25,10.25,0,0,0,.28,1.09c.1.36.23.7.34,1s.25.65.4.94a9,9,0,0,0,.4.82c.12.25.26.47.36.67l.31.51C46.6,128.85,46.71,129,46.71,129Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "20.32 82.71 0 39.3 27.43 0 75.19 4.11 95.51 47.52 68.08 86.82 20.32 82.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M66.4,83.25,22.58,79.48,3.93,39.64,29.1,3.57,72.93,7.34,91.58,47.18ZM24.29,77l40.85,3.51L88.6,46.92,71.22,9.79,30.37,6.28,6.91,39.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M16.36,45.91A11.08,11.08,0,0,0,21,47.49c2,.17,3.06-.55,3.16-1.78s-.73-1.93-2.93-2.93c-3-1.37-4.93-3.28-4.7-6,.28-3.21,3.18-5.45,7.63-5.06a11.61,11.61,0,0,1,4.73,1.36l-1.25,3.36a9,9,0,0,0-3.87-1.23c-1.84-.16-2.81.6-2.9,1.58-.1,1.2.92,1.83,3.27,3,3.23,1.52,4.64,3.38,4.42,6-.28,3.16-2.94,5.64-8.12,5.2a12.42,12.42,0,0,1-5.24-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M35.9,36.63l-5.06-.44.31-3.58,14.49,1.24-.31,3.59L40.18,37,38.87,52.27l-4.28-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M63.56,44.7C63,50.88,59,54.31,53.45,53.83s-8.51-5-8.05-10.36c.49-5.65,4.46-9.56,10-9.08C61.22,34.89,64,39.49,63.56,44.7Zm-13.64-.92c-.32,3.69,1.19,6.44,4,6.69s4.77-2.36,5.09-6c.29-3.39-1.09-6.43-4-6.69S50.23,40.11,49.92,43.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M67.14,36a35.36,35.36,0,0,1,5.79.1c2.63.23,4.46.89,5.64,2a5.52,5.52,0,0,1,1.63,4.54,6,6,0,0,1-2.11,4.32,8.75,8.75,0,0,1-6.3,1.46,11.12,11.12,0,0,1-1.45-.21l-.58,6.75-4.22-.37Zm3.48,8.92a6.77,6.77,0,0,0,1.42.24c2.27.19,3.76-.84,3.93-2.77.15-1.73-1-2.87-3.09-3.05a7.54,7.54,0,0,0-1.78,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M38.6,166.18l-3.86-.34a1.46,1.46,0,0,1-1.33-1.58L40.3,84.39l6.78.59-6.89,79.86A1.48,1.48,0,0,1,38.6,166.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "46.92 86.83 39.93 88.67 40.3 84.39 47.08 84.98 46.92 86.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M50,134.17h0a2.63,2.63,0,0,1-3.2-2.25L44,111.26a3.13,3.13,0,0,1,2.43-3.42h0a2.63,2.63,0,0,1,3.2,2.25l3.11,18.42C53,130.08,51.55,133.85,50,134.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M28.22,135.09l4.5,2.41a2.13,2.13,0,0,0,3-.65l.89-2a2.17,2.17,0,0,0-.43-2.23,3.36,3.36,0,0,0-.86-.72l-4.58-2.45-.21-.11a2.42,2.42,0,0,0-.35-.12,2,2,0,0,0-2.47.88l-.9,2A2.48,2.48,0,0,0,28.22,135.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M31.41,116h.14a2.86,2.86,0,0,0,.35,0,3.13,3.13,0,0,0,1-.15,3,3,0,0,0,.85-.46,2.28,2.28,0,0,0,.26-.23l.11-.1,0,.14a1.59,1.59,0,0,1-.15.35,1.45,1.45,0,0,1-.35.41,1.86,1.86,0,0,1-.55.31,2,2,0,0,1-.63.09,1.65,1.65,0,0,1-.53-.12,1.12,1.12,0,0,1-.32-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M26.44,127.42h0l.33.19.11.06.17.08,3.7,1.84,3.91,1.94a2.37,2.37,0,0,0,.34.13s0,0,0,0a2,2,0,0,0,2.3-1l1-2a2,2,0,0,0-.57-2.45,1,1,0,0,0-.24-.17l-.06,0,0,0-7.9-3.91-.34-.13h0a2,2,0,0,0-2.32,1l-1,2A2,2,0,0,0,26.44,127.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M28.45,121.72h0a3.28,3.28,0,0,0,.31.2l7.93,3.93.06,0,.54.27h0l.65.33a2,2,0,0,0,2.66-.9l1-2a2,2,0,0,0-.9-2.66l-.64-.32h0l-8.3-4.12-.24-.11a1.58,1.58,0,0,0-.34-.13h0a2,2,0,0,0-2.32,1l-1,2A2,2,0,0,0,28.45,121.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M28.83,122l.07,0c.24.14.58.36,1,.59.84.48,2,1.08,3.12,1.65s2.33,1.09,3.22,1.46l1.08.44.09,0,.3.11h0l-.38-.22c-.24-.15-.58-.37-1-.6-.84-.48-2-1.08-3.12-1.65s-2.33-1.09-3.22-1.47L28.94,122a.32.32,0,0,0-.09,0,1.69,1.69,0,0,0,.32.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M37.43,112.53l-2.09-1a2.71,2.71,0,0,0-3.66,1.06l-.49,1c-.61,1.31-.4,2.29.29,2.87a2.55,2.55,0,0,0,.39.24l8.13,4,.11,0a2,2,0,0,0,2.55-.94l1-2a2,2,0,0,0-.9-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M31.46,116.41l.07,0c.24.14.58.36,1,.6.83.48,2,1.09,3.11,1.67s2.31,1.11,3.2,1.49c.44.19.81.33,1.08.44l.41.16-.06,0-.31-.19c-.24-.14-.58-.36-1-.6-.83-.49-2-1.1-3.11-1.67s-2.31-1.13-3.2-1.5l-1-.41a1.7,1.7,0,0,0,.38.26l-.24-.12A1.4,1.4,0,0,0,31.46,116.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M30.35,129.64c.25.14.53.4.77.53,1.31.72,2.64,1.4,3.64,1.89.5.24.93.42,1.22.56s.47.21.47.21h0l-.41-.27c-.28-.18-.67-.44-1.14-.73-1-.59-2.26-1.35-3.57-2.06a7.08,7.08,0,0,0-.88-.39l-.52-.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "45.43 144.42 44.68 143.51 55.97 133.38 45.38 144.46 45.43 144.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M101.32,167s-1,15.81-1.35,22.6-2,53.59-2,53.59l1.47-72.58-21.62,7.12Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-37",
    points: "43.79 123.06 42.16 141.95 43.34 141.88 43.79 123.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153.73,430.23c17.63,9.62,2.78,21.19-33.17,25.84s-79.37.61-97-9-2.77-21.19,33.17-25.83S136.11,420.61,153.73,430.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M161.2,434.3q-.6-2.66-1.22-5.32a5.06,5.06,0,0,1,.13,1.28A5.06,5.06,0,0,0,160,429a10.37,10.37,0,0,0-2.58-4.68,11.29,11.29,0,0,0-.91-.92c-.56-.5-1.34-1.12-1.93-1.58s-1.77-1.15-2.54-1.62c-1-.54-2.37-1.23-3.41-1.71s-2.1-.91-3-1.24c-1.78-.65-4.18-1.42-6-2-1.17-.35-2.74-.73-3.92-1-2.68-.66-7-1.48-8-1.64-1.29-.21-3-.51-4.3-.69-2.69-.36-6.28-.82-9-1.08a225.29,225.29,0,0,0-24.33-1c-3.61.06-3.61.06-10,.36-1.49.07-3.46.24-4.94.35s-4.54.38-9.72,1.05c-.42.05-4.2.54-8.77,1.42-2.3.44-5.34,1.17-7.62,1.73A71.92,71.92,0,0,0,39,418.17a37.26,37.26,0,0,0-4.75,2.47,21.34,21.34,0,0,0-3.57,2.72,13.63,13.63,0,0,0-1.37,1.52,11.44,11.44,0,0,0-.92,1.36,10.59,10.59,0,0,0-.61,1.28,8.51,8.51,0,0,0-.39,1.24c-.05.21-.05.42-.08.64,0-.22,0-.43.08-.64-.41,1.77-.83,3.54-1.24,5.32-.74,3.16,1.4,6.42,6.78,9.48,16.45,9.34,57,13.26,90.51,8.75C148.79,448.9,162.9,441.67,161.2,434.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M150.33,419.87c15.34,8.72,2.42,19.19-28.86,23.4s-69.07.55-84.41-8.17-2.41-19.18,28.87-23.39S135,411.16,150.33,419.87ZM134.74,422c-11.11-6.32-38.5-9-61.17-5.92s-32,10.64-20.91,17,38.5,9,61.16,5.91,32-10.64,20.92-16.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M105.89,308.82a6.39,6.39,0,0,0-3.11-3.78,14.09,14.09,0,0,0-5.46-1.58,29.8,29.8,0,0,0-7.19,0,12.61,12.61,0,0,0-5.61,1.85A6.43,6.43,0,0,0,82.83,307a6,6,0,0,0-.88,1.81c-.16.57.21,1.17,1.19,1.73,2.92,1.65,10.11,2.35,16.06,1.55C103.75,311.45,106.26,310.14,105.89,308.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M48.12,426.41l3.39-11.76c.5-1.77,1.18-4.12,1.69-5.88,1-3.53,2.37-8.24,3.38-11.77S59,388.77,60,385.24c.51-1.77,1.19-4.12,1.69-5.88,1-3.53,2.37-8.24,3.39-11.77s2.37-8.23,3.38-11.76c.51-1.77,1.18-4.12,1.69-5.88,1-3.53,2.37-8.24,3.38-11.77l3.39-11.76c.5-1.76,1.18-4.12,1.69-5.88,1-3.53,2.37-8.24,3.38-11.77-.16.58.21,1.18,1.19,1.74,2.92,1.65,10.11,2.35,16.06,1.55,4.55-.61,7.06-1.92,6.69-3.24h0c1,3.53,2.33,8.24,3.34,11.77s2.33,8.24,3.34,11.78l3.33,11.77c1,3.53,2.34,8.24,3.34,11.77s2.34,8.25,3.34,11.78l3.34,11.77,1.67,5.89c1,3.53,2.34,8.24,3.34,11.78l3.34,11.77,1.67,5.89,3.34,11.77c1.43,5.05-8.13,10-25.46,12.36-22.66,3.05-50,.4-61.16-5.91C48.91,430.88,47.49,428.61,48.12,426.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M121.34,363.32c.87,3-4.9,6.05-15.37,7.46-13.69,1.84-30.23.24-36.94-3.57-2.26-1.29-3.12-2.66-2.74-4l3.39-11.76c.5-1.77,1.18-4.12,1.69-5.88.7-2.44,1.63-5.69,2.34-8.13-.28,1,.34,2,2,2.92,4.92,2.79,17,4,27.06,2.61,7.66-1,11.89-3.23,11.26-5.46,1,3.53,2.33,8.24,3.34,11.77.5,1.77,1.16,4.12,1.67,5.89l2.3,8.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M134.68,410.35c1.28,4.52-7.3,9-22.87,11.1-20.36,2.74-45,.36-54.95-5.32-3.37-1.91-4.64-3.95-4.08-5.92,1-3.53,2.37-8.24,3.39-11.77.5-1.76,1.18-4.11,1.69-5.88l2.33-8.12c-.46,1.61.59,3.29,3.35,4.86,8.18,4.65,28.36,6.6,45.07,4.35,12.77-1.71,19.81-5.39,18.75-9.1l7.32,25.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "159.98 428.98 159.98 428.98 159.98 428.98 159.98 428.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M586.82,421.22c35.95,4.64,50.8,16.21,33.18,25.83s-61.06,13.67-97,9-50.8-16.22-33.18-25.84S550.88,416.57,586.82,421.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M482.35,434.3l1.23-5.32a5.06,5.06,0,0,0-.13,1.28,5.06,5.06,0,0,1,.13-1.28,10.37,10.37,0,0,1,2.58-4.68,11.29,11.29,0,0,1,.91-.92c.56-.5,1.34-1.12,1.93-1.58s1.77-1.15,2.54-1.62c1-.54,2.37-1.23,3.41-1.71s2.1-.91,3-1.24c1.78-.65,4.18-1.42,6-2,1.17-.35,2.74-.73,3.92-1,2.68-.66,7-1.48,8-1.64,1.29-.21,3-.51,4.29-.69,2.69-.36,6.29-.82,9-1.08a225.29,225.29,0,0,1,24.33-1c3.61.06,3.61.06,10,.36,1.48.07,3.46.24,4.94.35s4.54.38,9.72,1.05c.42.05,4.2.54,8.76,1.42,2.31.44,5.35,1.17,7.62,1.73a72,72,0,0,1,10.07,3.41,37.26,37.26,0,0,1,4.75,2.47,20.8,20.8,0,0,1,3.56,2.72,12.22,12.22,0,0,1,1.38,1.52,12.78,12.78,0,0,1,.92,1.36,10.59,10.59,0,0,1,.61,1.28,8.51,8.51,0,0,1,.39,1.24,4.48,4.48,0,0,1,.07.64,4.48,4.48,0,0,0-.07-.64c.41,1.77.83,3.54,1.24,5.32.74,3.16-1.4,6.42-6.78,9.48-16.45,9.34-57,13.26-90.52,8.75C494.77,448.9,480.66,441.67,482.35,434.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M577.63,411.71c31.28,4.21,44.2,14.68,28.86,23.39s-53.12,12.37-84.4,8.17-44.2-14.68-28.86-23.4S546.35,407.5,577.63,411.71ZM508.82,422c-11.11,6.31-1.75,13.9,20.92,16.95s50,.4,61.16-5.91,1.75-13.91-20.92-17-50.05-.4-61.16,5.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M537.67,308.82a6.39,6.39,0,0,1,3.11-3.78,14.09,14.09,0,0,1,5.46-1.58,29.8,29.8,0,0,1,7.19,0,12.67,12.67,0,0,1,5.61,1.85,6.43,6.43,0,0,1,1.69,1.62,6,6,0,0,1,.88,1.81c.16.57-.21,1.17-1.19,1.73-2.92,1.65-10.11,2.35-16.06,1.55C539.81,311.45,537.3,310.14,537.67,308.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M595.43,426.41c-1-3.53-2.36-8.23-3.38-11.76-.51-1.77-1.18-4.12-1.69-5.88-1-3.53-2.37-8.24-3.38-11.77s-2.37-8.23-3.38-11.76l-1.7-5.88c-1-3.53-2.36-8.24-3.38-11.77s-2.37-8.23-3.38-11.76c-.51-1.77-1.19-4.12-1.69-5.88-1-3.53-2.37-8.24-3.39-11.77s-2.36-8.23-3.38-11.76c-.51-1.76-1.18-4.12-1.69-5.88-1-3.53-2.37-8.24-3.38-11.77.16.58-.21,1.18-1.19,1.74-2.92,1.65-10.11,2.35-16.06,1.55-4.56-.61-7.06-1.92-6.69-3.24h0l-3.34,11.77c-1,3.53-2.34,8.24-3.34,11.78s-2.33,8.24-3.34,11.77-2.33,8.24-3.34,11.77L521,367.69c-1,3.53-2.34,8.24-3.34,11.77L516,385.35c-1,3.53-2.34,8.24-3.34,11.78l-3.34,11.77-1.67,5.89-3.34,11.77c-1.43,5.05,8.13,10,25.46,12.36,22.66,3.05,50,.4,61.16-5.91C594.65,430.88,596.07,428.61,595.43,426.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M522.22,363.32c-.87,3,4.9,6.05,15.37,7.46,13.69,1.84,30.22.24,36.94-3.57,2.26-1.29,3.12-2.66,2.73-4-1-3.53-2.36-8.23-3.38-11.76-.51-1.77-1.18-4.12-1.69-5.88l-2.34-8.13c.28,1-.35,2-2,2.92-4.92,2.79-17,4-27.06,2.61-7.66-1-11.89-3.23-11.26-5.46l-3.34,11.77-1.67,5.89-2.3,8.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M508.88,410.35c-1.28,4.52,7.3,9,22.87,11.1,20.36,2.74,45,.36,55-5.32,3.37-1.91,4.64-3.95,4.07-5.92-1-3.53-2.36-8.24-3.38-11.77-.51-1.76-1.18-4.11-1.69-5.88-.7-2.44-1.63-5.69-2.34-8.12.47,1.61-.58,3.29-3.34,4.86-8.19,4.65-28.37,6.6-45.07,4.35-12.77-1.71-19.81-5.39-18.75-9.1l-7.32,25.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "483.58 428.98 483.57 428.98 483.58 428.98 483.58 428.98"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessDenied);
export default __webpack_public_path__ + "static/media/access_denied.66528bac46a7f3b5ed44735aacbcfefd.svg";
export { ForwardRef as ReactComponent };